import { render, staticRenderFns } from "./DateLabel.vue?vue&type=template&id=3b028ba6&"
import script from "./DateLabel.vue?vue&type=script&lang=ts&"
export * from "./DateLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports